import styled from '../../../styles/styled';
import { Grid } from '../../layout';
export const CheckboxGridContainer = styled(Grid)(({ itemsPerRow = 1 }) => ({
    gridTemplateColumns: `repeat(${itemsPerRow}, 1fr)`,
    columnGap: '1rem',
    // These aren't really needed but it makes a nicer view if
    // if you have the console or inspector open
    '@media (max-width: 1124px)': {
        gridTemplateColumns: `repeat(${Math.min(itemsPerRow, 2)}, 1fr)`,
    },
    '@media (max-width: 600px)': {
        gridTemplateColumns: 'repeat(1, 1fr)',
    },
}));
CheckboxGridContainer.defaultProps = {
    width: '45vw',
};
//# sourceMappingURL=checkbox_grid_container.js.map